import { GET } from "@/services/request";
import * as APIs from '@/services/APIs';

/**
 * 获取预约项目和预约状态数据
 */
export const fetchSubscribeOption = async () => {
    const res = await GET(APIs.API_SUBSCRIBE_OPTIONSTATUS);

    return res.data.data ?? {};
};

/**
 * 获取贵宾休息室，导购大使，代客泊车的时间和数量,以及次数
 */
export const fetchSubscribeSurplus = async (date) => {
    const res = await GET(APIs.API_SUBSCRIBE_SURPLUSCOUNTSUBSCRIBE, { params: { date } });

    return res.data.data ?? {};
};

/**
 * 获取贵宾休息室预约时间段,代客泊车,导购大使预约时间数据(预约详情时用)
 * - type 预约项目 101贵宾休息室 7代客泊车 175导购大使
 */
export const fetchSubscribeInfoSurplus = async (shopping_village, date, type) => {
    const res = await GET(APIs.API_SUBSCRIBE_TIMESLOTDATA, { params: { shopping_village, date, type } });

    return res.data.data ?? {};
};